<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/304VQ1/tc-custom/9781684813926.jpg?1733094887779" alt="This image is the cover for the book Book of Vintage Board Games"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of Vintage Board Games
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover and Delight in Old-Fashioned Board Games from the Past</b></p><p><b>Discover the world of old-fashioned board games from <i>Wall Street Journal </i>acclaimed Adrian Seville, an international expert on the cultural history of printed board games.</b></p><p><b>The golden age of board games.</b> Explore the world of vintage board games in this lavishly illustrated book that traces their evolution and cultural significance. From geography and moral lessons to just fun, discover the diverse array of old-fashioned board games from a bygone era.</p><p><b>Step back in time. </b>Delve into a bygone era of gaming with this remarkable illustrated board game book. It showcases the exquisite artistry and ingenuity of these games, which covered themes ranging from educational to gambling to simply pure entertainment. Learn all about the moral board games that aimed to instill proper behavior or immerse yourself in the excitement of lottery board games, all while gaining insights into the cultural influences that shaped these games. <i>The Book of Vintage Board Games </i>offers a glimpse into where games started in Europe and the emergence of board games in America.</p><p><b>Inside explore:</b></p>The history of geography board games and moreDistant lands through war or journey board gamesA treasure trove of beautifully designed boards each reflecting its unique historical context<p></p><p><b>If you enjoyed board game books such as <i>Board and Table Games from Many Civilizations</i>, <i>Oxford History of Board Games</i>, or <i>Seven Games: A Human History</i>, then you will love Adrian Seville’s <i>The Book of Vintage Board Games</i>.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adrian Seville
      </h2>
      
      <p class="authorDescription body article"><P><B>Adrian&#10;Seville </B>is an international expert on the cultural history of printed&#10;board games and has lectured widely on his research, both in Europe and&#10;America. He studied at Cambridge and Edinburgh universities before joining the staff&#10;of City University, London, where he was Academic Registrar. His New York&#10;exhibition of board games at the Grolier Club in 2016 was described by&#10;<I>The Wall Street Journal </I>as &#34;a mind-opening cultural&#10;event.&#34; He has written the books <I>The Cultural Legacy of the&#10;Royal Game of the Goose</I> and <I>Vintage Board&#10;Games</I>. Adrian currently resides in Royston, England, United&#10;Kingdom.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36e1b395